(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSProyectoDetailController', SSProyectoDetailController);

    SSProyectoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SSProyecto', 'SSPersona', 'SSUnidadReceptora', 'SSPerfil', 'SSPeriodo', 'SSArea', 'SSFuncion', 'SSModalidad', 'SSAsignacion', 'CartaLiberacionDownloadService', 'CartaAsignacionDownloadService', 'AlertService'];

    function SSProyectoDetailController($scope, $rootScope, $stateParams, entity, SSProyecto, SSPersona, SSUnidadReceptora, SSPerfil, SSPeriodo, SSArea, SSFuncion, SSModalidad, SSAsignacion, CartaLiberacionDownloadService, CartaAsignacionDownloadService, AlertService) {
        var vm = this;
        vm.cartaLiberacion = cartaLiberacion;
        vm.cartaAsignacion = cartaAsignacion;

        entity.$promise.then(function(result) {
        	vm.sSProyecto = result;
        	vm.periodos = result.periodos;
        	vm.selectedPeriodo = vm.periodos[0];
        });
        
        var unsubscribe = $rootScope.$on('serviciosocialApp:sSProyectoUpdate', function(event, result) {
            vm.sSProyecto = result;
        });
        
        $scope.$on('$destroy', unsubscribe);
        
        $scope.filterPerfiles = function (item) { 
			var currentAssignations = item.asignacions.filter(function(e){
				return (e.periodo.id == vm.selectedPeriodo.id && e.estatusPrestador != 'BAJA');	
			});
			return item.bajaReg === null || currentAssignations.length > 0
		};
		
		$scope.filterAsignacionesActivasEnPeriodo = function (item) { 
				return (item.periodo.id == vm.selectedPeriodo.id && item.estatusPrestador != 'BAJA');	
		};
		
        
        function cartaLiberacion(idAsignacion, matricula) {
        	CartaLiberacionDownloadService.download(idAsignacion, matricula)
            .then(function(data) {
            	AlertService.success("Carta de liberación generada.");
            })
            .catch(function(err) {
            	AlertService.error("Ocurrió un error al generar la carta de liberación");
           	});
        }
        
        function cartaAsignacion(asignacion, matricula) {        	
        	SSAsignacion.validarStatusAlumno({
				idAsignacion : asignacion
			}).$promise.then(function(result) {
				if(result.estatus == true){
		        	CartaAsignacionDownloadService.download(asignacion, matricula)
		            .then(function(data) {
		            	AlertService.success("Carta de asignación generada.");
		            })
		            .catch(function(err) {
		            	AlertService.error("Ocurrió un error al generar la carta de asignación");
		           });
		        } else {
					AlertService.error("El alumno no está activo en el plan de estudios.", {toast: true, position: 'bottom right'});					
				}
			});

        }
    }
})();
